export default function ibanFormater(value) {
  if (!value || value.length === 0) {
    return value;
  }
  const local = value.replace(/ /g, '').split('');
  const longueur = local.length;
  if (longueur <= 4) return local.join('');
  local.splice(4, 0, ' ');
  if (longueur <= 8) return local.join('');
  local.splice(9, 0, ' ');
  if (longueur <= 12) return local.join('');
  local.splice(14, 0, ' ');
  if (longueur <= 16) return local.join('');
  local.splice(19, 0, ' ');
  if (longueur <= 20) return local.join('');
  local.splice(24, 0, ' ');
  if (longueur <= 24) return local.join('');
  local.splice(29, 0, ' ');
  return local.join('');
}
